import { FormCheckbox, FormPhoneField, FormTextField } from 'components/form';
import { Column, Header, Row, Spacer, Typo } from 'components/ui-kit';
import { useFormikContext } from 'formik';
import Link from 'next/link';
import { useUserInfoContext } from 'providers/auth-provider/user-info-provider';
import React from 'react';
import { RUSSIA_CODE } from '../../offer-form.consts';

export const PesonalDataForm = (): JSX.Element => {
  const { profile } = useUserInfoContext();
  const { values } = useFormikContext<{ country?: string }>();
  const IS_FOREIGN_COUNTRY = RUSSIA_CODE !== values.country?.toLowerCase();
  return (
    <>
      <Header weight="600" level={3}>
        Личные данные
      </Header>
      <Row>
        <Column span={{ s: 12, l: 6 }}>
          <FormTextField label="Имя *" name="name" />
          <Spacer size={24} />
          <FormTextField label="E-mail *" name="email" />
        </Column>
        <Column span={{ s: 12, l: 6 }}>
          <FormTextField label="Фамилия *" name="lastName" />
          <Spacer size={24} />
          <FormPhoneField
            label="Телефон *"
            name="phone"
            hasNotMask={IS_FOREIGN_COUNTRY}
          />
        </Column>
        {!profile && (
          <Column span={{ s: 12 }}>
            <FormCheckbox
              name="agreement"
              label={
                <Typo variant="xm">
                  Принимаю{' '}
                  <Link href="/concent">
                    условия обработки персональных данных
                  </Link>{' '}
                  и&nbsp;
                  <Link href="/privacy">политики конфиденциальности</Link>
                </Typo>
              }
            />
          </Column>
        )}
      </Row>
    </>
  );
};
